import Vue from 'vue';

import './styles/app.scss';
import './styles/quasar.scss';
import './styles/boxicons.min.css';
import '@quasar/extras/material-icons/material-icons.css';
import 'driver.js/dist/driver.min.css';
import 'quasar/dist/quasar.ie.polyfills';
import lang from 'quasar/lang/es';
import { Quasar, Notify } from 'quasar';

Vue.use(Quasar, {
  config: {
    screen: {
      bodyClasses: true,
    },
  },
  components: {
    /* not needed if importStrategy is not 'manual' */
  },
  directives: {
    /* not needed if importStrategy is not 'manual' */
  },
  plugins: {
    Notify,
  },
  lang,
});
